module.exports = __webpack_public_path__ + "static/media/dropdown_white.dc276ba7.svg";